import React, {useContext, useEffect, useState} from "react";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Chip,
  Grid,
  Input,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import {Close} from "@mui/icons-material";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";

import profileImg from "../../../assets/images/profileImg.svg";
import user_white from "../../../assets/images/user-white.svg";
import money_white from "../../../assets/images/currency-white.svg";

import "./profile.css";
import {ThemeProvider, createTheme} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import moment from "moment";
import axiosClient from "../../../utils/axios-client";
import {useVarAuth} from "../../../graphql/graphql/auth/defaults";
import {useProfile, useUpdateProfileData} from "../../../graphql/graphql/profile/hooks";
import {uploadImage} from "../../../utils/upload";

export const TradingFrequencyOptions = [
  {
    title: "Professional",
    icon: user_white,
    value: "professional",
  },
  {
    title: "Part time trader",
    icon: user_white,
    value: "partTime",
  },
  {
    title: "Full time trader",
    icon: money_white,
    value: "fullTime",
  },
  {
    title: "Investor",
    icon: user_white,
    value: "investor",
  },
];

const back = 10;
const year = new Date().getFullYear();
export const TradingYearOptions = Array.from({length: back}, (v, i) => {
  let value = year - i - 1;
  return {
    title: `${value} (${i > back - 2 ? `${back}+` : i + 1} yr)`,
    value: moment(value, "YYYY").utc().toISOString(),
  };
});

const tradingStyle = ["Long Term", "Swing", "Short Term", "Roth IRA", "Day Trading", "Options", "Naked Options", "Covered Options", "Scalping", "Meme", "0DTE", "Price Action", "Technical Analysis", "News Plays"];

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});
const initMessage = {show: false, mode: "success", message: ""};
const Profile = () => {
  //console.log("🚀 ~ file: profile.jsx:63 ~ TradingYearOptions ~ TradingYearOptions:", TradingYearOptions);

  const [editWebsite, setEditWebsite] = useState(false);
  const [bioValid, setBioValid] = useState(true);
  const [tempBioText, setTempBioText] = useState("");
  const [messsage, setMessage] = useState(initMessage);
  const [editBio, setEditBio] = useState(false);
  const {data, loading} = useProfile();
  const {updateProfile} = useUpdateProfileData();
  const [profileData, setProfiledata] = useState();
  useEffect(() => {
    if (data) {
      //console.log("🚀 ~ file: profile.jsx:85 ~ useEffect ~ data:", data);
      setProfiledata({
        phone: data.phone,
        tradingSince: data.tradingSince && moment(data.tradingSince).utc().toISOString(),
        tradingFrequency: data.tradingFrequency,
        website: data.website,
        tradeStyle: data.tradeStyle,
        bio: data.bio || "",
        avatar: data.avatar,
      });
    }
  }, [data]);

  const [isFreqDropdownOpen, setIsFreqDropdownOpen] = useState(false);
  const [isTradingSinceOpen, setIsTradingSinceOpen] = useState(false);

  //console.log("🚀 ~ file: profile.jsx:102 ~ Profile ~ profileData:", profileData);

  function handleChange(key, value, updateInApi = true) {
    setProfiledata((o) => {
      return {
        ...o,
        [key]: value,
      };
    });
    if (updateInApi) {
      // axiosClient
      // .post("/profile/update", {
      //   [key]: value,
      // })
      updateProfile({[key]: value})
        .then((response) => {
          setMessage({show: true, message: "Data Updated Successfully", mode: "success"});
        })
        .catch((e) => {
          //console.log("🚀 ~ file: profile.jsx:122 ~ handleChange ~ e:", e);
          setMessage({show: true, message: "Error updating Data", mode: "error"});
        });
    }
  }

  // console.log("da", profileData);
  if (!profileData) return null;
  //console.log("🚀 ~ file: profile.jsx:341 ~ Profile ~ profileData:", profileData);

  return (
    <ThemeProvider theme={darkTheme}>
      <Snackbar
        open={messsage.show}
        autoHideDuration={3000}
        onClose={() => {
          setMessage(initMessage);
        }}
        anchorOrigin={{horizontal: "right", vertical: "top"}}
      >
        <Alert severity={messsage.mode} sx={{width: "100%"}}>
          {messsage.message}
        </Alert>
      </Snackbar>
      <CssBaseline />

      <Box className="profileMain">
        <Typography className="profile-title setting_page_heading" variant="h4">
          Profile
        </Typography>
        <Box className="main">
          <Box className="avtarSect">
            <Typography variant="h6" mb={2}>
              Avatar
            </Typography>
            <Box display="flex" alignItems="center">
              <img src={data.avatar || profileImg} alt="profile" />
              <Box className="changeAvtar">
                <label className="text-white">Change Avatar</label>
                <input
                  type="file"
                  onChange={async (e) => {
                    const {data} = await uploadImage(e.target.files[0]);
                    handleChange("avatar", data.original);
                    //console.log("🚀 ~ file: profile.jsx:164 ~ Profile ~ data:", data);
                  }}
                />
              </Box>
            </Box>
          </Box>

          {/* Trading frequency */}
          <Box className="tdFrequency">
            <Typography variant="h6"> Trading Frequency</Typography>
            <Box display="flex" alignItems="center" justifyContent="space-between">
              <Select
                fullWidth
                value={profileData.tradingFrequency || ""}
                displayEmpty
                size="small"
                className="select_box"
                disableUnderline={true}
                variant="standard"
                autoFocus={false}
                IconComponent={KeyboardArrowDownRoundedIcon}
                renderValue={profileData.tradingFrequency ? undefined : () => "Select frequency"}
                sx={{
                  width: {md: "55%", lg: "50%"},
                  background: "linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), #0F0F0F;",
                  borderRadius: "8px",
                  color: "rgba(255, 255, 255, 0.6)",
                  mt: "8px",
                  height: "44px",
                  // caret styling
                  ".MuiSelect-icon": {
                    color: "rgba(255, 255, 255, 0.38)",
                    mr: "10px",
                  },
                  border: isFreqDropdownOpen ? "1px solid #EDA044" : "none",
                  ".MuiSelect-standard span": {
                    color: "rgba(255, 255, 255, 0.6)",
                    pl: "12px",
                  },
                  ".MuiSelect-standard": {
                    pl: "14px",
                    pt: "5px",
                  },
                }}
                MenuProps={{
                  sx: {
                    ".MuiMenu-paper": {
                      mt: profileData.trading_frequency ? "5px" : "1px", // Menu margin top differs is there is a selection
                      // Menu background
                      background:
                        "linear-gradient(0deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.08)), #0F0F0F;",
                      boxShadow: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);",
                    },
                    ".MuiMenu-list": {
                      color: "rgba(255, 255, 255, 0.6)", // Menu item color
                    },
                  },
                }}
                onChange={(e) => handleChange("tradingFrequency", e.target.value)}
                onOpen={() => setIsFreqDropdownOpen(true)}
                onClose={() => setIsFreqDropdownOpen(false)}
              >
                {TradingFrequencyOptions.map((item, indx) => {
                  return (
                    <MenuItem
                      value={item.value}
                      sx={{
                        "&.Mui-selected": {
                          background:
                            "linear-gradient(0deg, rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.12)), #0F0F0F;",
                          borderRadius: "6px",
                          mx: "6px",
                          pl: "10px",
                          // Show checkmark only for selected
                          "& :last-of-type svg": {
                            opacity: 1,
                          },
                        },
                      }}
                    >
                      <ListItemIcon sx={{ml: "0px"}}>
                        <img
                          src={item.icon}
                          alt="profile"
                          // extra margin needed for $ icon
                          style={{marginLeft: item.value === 1 ? "2px" : "none"}}
                        />
                      </ListItemIcon>
                      <ListItemText primary={item.title} sx={{ml: "-10px"}} />
                      <ListItemIcon sx={{ml: "0px", mr: "-16px"}}>
                        <CheckRoundedIcon sx={{opacity: 0, color: "rgba(237, 160, 68, 1)"}} />
                      </ListItemIcon>
                    </MenuItem>
                  );
                })}
              </Select>
            </Box>
          </Box>

          {/* Trading since */}
          <Box className="tdyear">
            <Typography variant="h6" lineHeight="16px">
              Trading Since
            </Typography>
            <Select
              fullWidth
              value={profileData.tradingSince || ""}
              displayEmpty
              size="small"
              className="select_box"
              disableUnderline={true}
              variant="standard"
              autoFocus={false}
              IconComponent={KeyboardArrowDownRoundedIcon}
              renderValue={profileData.tradingSince ? undefined : () => "Select years"}
              sx={{
                width: {md: "55%", lg: "50%"},
                background: "linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), #0F0F0F;",
                borderRadius: "8px",
                color: "rgba(255, 255, 255, 0.6)",
                mt: "8px",
                height: "44px",
                // caret styling
                ".MuiSelect-icon": {
                  color: "rgba(255, 255, 255, 0.38)",
                  mr: "10px",
                },
                border: isTradingSinceOpen ? "1px solid #EDA044" : "none",
                ".MuiSelect-standard span": {
                  color: "rgba(255, 255, 255, 0.6)",
                  pl: "12px",
                },
                ".MuiSelect-standard": {
                  pl: profileData.tradingSince ? "0px" : "14px",
                  pt: "5px",
                },
              }}
              MenuProps={{
                sx: {
                  ".MuiMenu-paper": {
                    mt: profileData.tradingSince ? "5px" : "1px", // Menu margin top differs is there is a selection
                    // Menu background
                    background: "linear-gradient(0deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.08)), #0F0F0F;",
                    boxShadow: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03);",
                  },
                  ".MuiMenu-list": {
                    color: "rgba(255, 255, 255, 0.6)", // Menu item color
                  },
                },
              }}
              onChange={(e) => handleChange("tradingSince", e.target.value)}
              onOpen={() => setIsTradingSinceOpen(true)}
              onClose={() => setIsTradingSinceOpen(false)}
            >
              {TradingYearOptions.map((item, indx) => {
                return (
                  <MenuItem
                    value={item.value}
                    sx={{
                      "&.Mui-selected": {
                        background:
                          "linear-gradient(0deg, rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.12)), #0F0F0F;",
                        borderRadius: "6px",
                        mx: "6px",
                        pl: "10px",
                        // Show checkmark only for selected
                        "& :last-of-type svg": {
                          opacity: 1,
                        },
                      },
                    }}
                  >
                    <ListItemText primary={item.title} />
                    <ListItemIcon sx={{ml: "0px", mr: "-16px"}}>
                      <CheckRoundedIcon sx={{opacity: 0, color: "rgba(237, 160, 68, 1)"}} />
                    </ListItemIcon>
                  </MenuItem>
                );
              })}
            </Select>
          </Box>

          {/* Trading style */}
          <Box className="tradingStyleSect">
            <Typography variant="h6">Trading style</Typography>
            <Autocomplete
              id="tags-standard"
              sx={{width: {md: "55%", lg: "50%"}}}
              ListboxProps={{
                sx: {
                  ".MuiAutocomplete-option[aria-selected=true]": {
                    background:
                      "linear-gradient(0deg, rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.12)), #0F0F0F !important",
                  },
                  ".MuiAutocomplete-option": {
                    color: "rgba(255, 255, 255, 0.6)",
                  },
                },
              }}
              multiple
              options={
                profileData.tradeStyle
                  ? tradingStyle.filter((ts) => !profileData.tradeStyle.split(",").includes(ts))
                  : tradingStyle
              }
              getOptionLabel={(option) => option}
              value={profileData.tradeStyle ? profileData.tradeStyle.split(",") : []}
              onChange={(e, newValues) => handleChange("tradeStyle", newValues.join(","))}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    variant="outlined"
                    label={option}
                    size="small"
                    deleteIcon={<Close />}
                    {...getTagProps({index})}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  placeholder="Add tags..."
                  sx={{
                    ".Mui-focused": {
                      border: "1px solid #EDA044",
                    },
                  }}
                />
              )}
            />
          </Box>

          {/* Bio text area*/}
          <Box className="bioSect">
            <Typography variant="h6">bio</Typography>
            <Box className="bioText" sx={{width: {md: "55%", lg: "50%"}, "div > div": {pb: "34px !important"}}}>
              <TextField
                id="outlined-multiline-static"
                disabled={!editBio}
                onChange={(e) => {
                  let value = e.target.value;
                  setBioValid(!value || value.length <= 240);
                  setTempBioText(value);
                }}
                placeholder="Add bio..."
                multiline
                rows={6}
                value={tempBioText}
                fullWidth
                sx={{
                  ".MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #EDA044",
                  },
                }}
              />
              <Typography className="endText" color={bioValid ? "rgba(255, 255, 255, 0.6)" : "rgba(255, 70, 48, 1)"}>
                {editBio && (240 - tempBioText.length ?? 240)}
              </Typography>
            </Box>

            {/* Bio buttons */}
            <Box display="flex" justifyContent="flex-end" sx={{width: {md: "55%", lg: "50%"}}}>
              {editBio ? (
                <Box display="flex">
                  <BioButton
                    onClick={() => {
                      setEditBio(false);
                      setTempBioText(profileData.bio);
                    }}
                    sx={{
                      background: "rgba(255, 255, 255, 0.38)",
                      "&:hover": {background: "rgba(255, 255, 255, 0.28)"},
                    }}
                  >
                    Cancel
                  </BioButton>

                  <BioButton
                    disabled={!bioValid}
                    onClick={() => {
                      handleChange("bio", tempBioText);
                      setEditBio(false);
                    }}
                    sx={{
                      ml: "10px",
                      ":disabled": {
                        background: "#4e3516",
                        color: "rgba(15, 15, 15, 1)",
                      },
                    }}
                  >
                    Save
                  </BioButton>
                </Box>
              ) : (
                <BioButton onClick={(e) => setEditBio(true)}>Edit</BioButton>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default Profile;

// ** Styled components
function BioButton({children, sx, ...props}) {
  return (
    <Button
      sx={{
        background: "rgba(237, 160, 68, 1)",
        color: "rgba(15, 15, 15, 1)",
        "&:hover": {background: "rgba(237, 160, 68, 0.8)"},
        textTransform: "capitalize",
        mt: "10px",
        px: "24px",
        fontWeight: 400,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
}
